import React from "react";

function HistoryIconNew({ iconBackground = "#F4F2F6" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
		>
			<rect width="20" height="20" fill={iconBackground} rx="4" />
			<path
				fill="#8C8594"
				d="M10 7.5v2.652l2.27 1.348.383-.645-1.857-1.1V7.5H10z"
			/>
			<path
				fill="#8C8594"
				d="M10.712 5.5c-2.37 0-4.283 1.903-4.283 4.25H5l1.855 1.84.033.068L8.81 9.75H7.38c0-1.825 1.493-3.306 3.333-3.306s3.334 1.48 3.334 3.306c0 1.825-1.493 3.306-3.334 3.306a3.334 3.334 0 01-2.354-.97l-.674.667A4.277 4.277 0 0010.712 14C13.08 14 15 12.097 15 9.75S13.081 5.5 10.712 5.5z"
			/>
		</svg>
	);
}

export default HistoryIconNew;
